import {Logo} from '@benchling/nucleus-ui';
import React from 'react';

import {ACCOUNT_TYPE_TO_LOGO, AccountType} from 'notebook/tfi/TFIConstants';

interface TFIAccountIconProps {
  accountType: AccountType;
}

const ACCOUNT_TYPE_TO_CLASS_NAME: Record<AccountType, string | undefined> = {
  [AccountType.BOX]: 'color--tfi-accountIcon-box',
  [AccountType.DROPBOX]: 'color--tfi-accountIcon-dropbox',
  [AccountType.EGNYTE]: undefined,
  [AccountType.ONEDRIVE]: 'color--tfi-accountIcon-onedrive',
  [AccountType.HOSTED_S3]: undefined,
};

export default function TFIAccountIcon({accountType}: TFIAccountIconProps): JSX.Element {
  const name = ACCOUNT_TYPE_TO_LOGO[accountType];
  const className = ACCOUNT_TYPE_TO_CLASS_NAME[accountType];
  return <Logo className={className} name={name} />;
}
